import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './services/auth.jsx'
import LoginPage from './pages/LoginPage.jsx'
import Dashboard from './pages/Dashboard.jsx'
import ActivitiesPage from './pages/ActivitiesPage.jsx'
import UsersPage from './pages/UsersPage.jsx'
import FazendasPage from './pages/FazendasPage.jsx'
import SafrasPage from './pages/SafrasPage.jsx'
import MecanizacaoPage from './pages/MecanizacaoPage.jsx'
import InsumosPage from './pages/InsumosPage.jsx'

function PrivateRoute({ children }) {
  const { user } = useAuth()
  return user ? children : <Navigate to="/login" replace />
}

function PublicRoute({ children }) {
  const { user } = useAuth()
  return user ? <Navigate to="/" replace /> : children
}

function AdminRoute({ children }) {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  if (user.role !== 'admin') return <Navigate to="/" replace />
  return children
}

function OwnerRoute({ children }) {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  if (!['admin', 'owner'].includes(user.role)) return <Navigate to="/" replace />
  return children
}

function MecanizacaoRoute({ children }) {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  if (!['admin', 'mecanizacao'].includes(user.role)) return <Navigate to="/" replace />
  return children
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login"        element={<PublicRoute><LoginPage /></PublicRoute>} />
        <Route path="/"             element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/fazendas"     element={<AdminRoute><FazendasPage /></AdminRoute>} />
        <Route path="/safras"       element={<AdminRoute><SafrasPage /></AdminRoute>} />
        <Route path="/activities"   element={<AdminRoute><ActivitiesPage /></AdminRoute>} />
        <Route path="/users"        element={<AdminRoute><UsersPage /></AdminRoute>} />
        <Route path="/mecanizacao"  element={<MecanizacaoRoute><MecanizacaoPage /></MecanizacaoRoute>} />
        <Route path="/insumos"      element={<OwnerRoute><InsumosPage /></OwnerRoute>} />
        <Route path="*"             element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  )
}
